import gql from 'graphql-tag';
import { useCustomQuery } from '../../../../logic/api/graphQL/useCustomQuery';
import {
  GoogleAdWordsProductAndServiceGq,
  GoogleAdWordsProductAndServiceGqProps,
} from '../../models/GoogleAdWordsProductAndServiceGq';

export default function useGetGoogleAdwordsCategoriesGq() {
  const query = useCustomQuery<ResponseGq, VariablesGq>(gqTag, {
    variables: { command: {} },
    fetchPolicy: 'cache-first',
  });

  return {
    query,
    result: (query?.data ?? query?.previousData)?.projects?.getGoogleAdWordsCategories?.categories,
  };
}

const gqTag = gql`
  query GetGoogleAdwordsCategories($command: GetGoogleAdwordsCategoriesCommand!) {
    projects {
      getGoogleAdWordsCategories(command: $command) {
        categories {
            ${GoogleAdWordsProductAndServiceGqProps}
        }
      }
    }
}`;

interface VariablesGq {
  command: GetGoogleAdwordsCategoriesCommand;
}

export interface GetGoogleAdwordsCategoriesCommand {}

interface ResponseGq {
  projects: {
    getGoogleAdWordsCategories: {
      categories: GoogleAdWordsProductAndServiceGq[];
    };
  };
}
